import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';
import {GlobalService} from '../../services/global/global.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent {
  public inputEmail: string;
  public inputPassword: string;
  public appVersion: string;
  public production = environment.production;
  public headerHidden: boolean;

  constructor(
    public globalService: GlobalService,
    public activatedRoute: ActivatedRoute,
  ) {
    this.inputEmail = '';
    this.inputPassword = '';
    this.appVersion = require('../../../../package.json').version;
  }

  public ApiVersionSelectChanged(): void {
    console.log('Api Version switched to ' + this.globalService.ApiVersion);
    this.globalService.TriggerReload();
  }

  public async login(): Promise<void> {
    try {
      await this.globalService.GetAuth().signInWithEmailAndPassword(this.inputEmail, this.inputPassword);
      document.location.reload();
    } catch (err) {
      this.globalService.ShowMessage(err);
    }
  }

  public async logout(): Promise<void> {
    try {
      await this.globalService.GetAuth().signOut();
      document.location.reload();
    } catch (err) {
      this.globalService.ShowMessage(err);
    }
  }
}
